import { MenuItem, TextField } from "@mui/material";

interface PaymentMethodFilterProps {
    value: string;
    onChange: (method: string) => void;
}

export function PaymentMethodFilter({
    value,
    onChange,
}: PaymentMethodFilterProps) {
    return (
        <TextField
            select
            size="small"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            SelectProps={{ displayEmpty: true }}
            sx={{ minWidth: 140 }}
        >
            <MenuItem value="">Todos</MenuItem>
            <MenuItem value="pix">PIX</MenuItem>
            <MenuItem value="card">Cartão</MenuItem>
        </TextField>
    );
}
